import { useLocaleField } from '@/hooks/useLocaleField';
import { sanityImage } from '@/utils/sanityImage';
import { Box, Flex, Text, useMediaQuery } from '@chakra-ui/react';
import Image from 'next/image';
import Link from 'next/link';
import { FC } from 'react';
import { MotionBox } from '../MotionBox';
import styles from './LinkWithImage.module.css';
import { LinkWithImageProps } from './LinkWithImage.props';

const LinkWithImage: FC<LinkWithImageProps> = ({ link, index,image }) => {
  const [isSmallerThan540] = useMediaQuery('(max-width: 540px)');

  const {getLocaleField} =useLocaleField();

  const delay = isSmallerThan540 ? 0.2 : 0.2 * index;

  // const isInternalLink = useMemo<boolean>(() => !!link?.url?.startsWith('/'), [link]);

  // type RWN = { children: React.ReactNode };
  // const LinkWrapper = useCallback(
  //   ({ children }: RWN) => {
  //     if (isInternalLink) {
  //       return <Link href={link?.url || '/'}>{children}</Link>;
  //     }

  //     return (
  //       <a
  //         href={link?.url || '/'}
  //         // Change target and rel attributes is newTab is turned on
  //         target={link?.newTab ? '_blank' : '_self'}
  //         rel="noreferrer"
  //       >
  //         {children}
  //       </a>
  //     );
  //   },
  //   [isInternalLink, link],
  // );

  return (
    <Link href={link?.url||'/'} title={getLocaleField(link?.title) ||''}>
      <MotionBox
        initial={{ opacity: 0, scale: 0.8 }}
        whileInView={{ opacity: 1, scale: 1 }}
        viewport={{ once: true }}
        transition={{ delay }}
        h="100%"
        w="100%"
      >
        <Box position="relative" className={styles.CardWrapper}>
          <Box className={styles.ImageWrapper}>
            {image&&
            <Image
              src={sanityImage(image)?.width(685).height(450).url()||''}
              width={685}
              height={500}
              alt={getLocaleField(link?.title) || 'Link'}
              className={styles.Image} />
            }
          </Box>
          <Flex justifyContent="center" alignItems="center" position="absolute" top={0} left={0} w="100%" h="100%">
            <Text
              fontSize={{ base: '2xl', md: '5xl' }}
              fontWeight="semibold"
              textTransform="uppercase"
              color="white"
              as="h5"
            >
              {getLocaleField(link?.title)}
            </Text>
          </Flex>
        </Box>
      </MotionBox>
    </Link>
  );
};

export { LinkWithImage };
